import React from 'react';
import { Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToOffer = () => {
    const el = document.getElementById('oferta');
    if (!el) return;
    // On desktop, align the bottom of the offer section to the viewport so the
    // "Oferta de lanzamiento por tiempo limitado" line is visible. On mobile,
    // align to the top (default) which already works well.
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    el.scrollIntoView({
      behavior: 'smooth',
      block: isDesktop ? 'end' : 'start'
    });
  };
  return <section className="relative pt-10 pb-10 md:pt-14 md:pb-16 overflow-hidden bg-ocean-cream" data-id="element-81">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center" data-id="element-83">
          {/* Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl order-2 lg:order-1 text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-84">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-ocean-teal-light text-ocean-teal-dark text-xs sm:text-sm font-medium mb-4 lg:mb-6" data-id="element-85">
              <span aria-hidden="true" data-id="element-86">✨</span>
              SISTEMA 360 LASH — GESTIÓN PARA LASHISTAS
            </div>

            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-[3.75rem] font-bold leading-[1.1] tracking-tight text-[#11213a] mb-5 lg:mb-7" data-id="element-87">
              Tu problema no es la técnica.
              <br className="hidden sm:block" data-id="element-88" /> Es{' '}
              <span className="text-[#11213a]" data-id="element-89">la</span>{' '}
              <span className="text-ocean-gold-dark" data-id="element-90">gestión</span>.
            </h1>

            <p className="font-sans text-base md:text-xl text-gray-600 mb-5 lg:mb-6 leading-relaxed" data-id="element-91">
              Mientras sigas{' '}
              <span className="font-semibold text-gray-800" data-id="element-92">improvisando</span>{' '}
              precios, atención y organización, vas a{' '}
              <span className="font-semibold text-ocean-teal" data-id="element-93">
                perder plata
              </span>{' '}
              todos los meses.
            </p>

            {/* Benefits list */}
            <div className="mb-6 lg:mb-7 grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-2.5 text-left" data-id="element-94">
              {['6 tomos prácticos', 'Protocolos listos para usar', 'Sistema de precios y rentabilidad', 'Políticas claras para frenar cancelaciones'].map(item => <div key={item} className="flex items-start gap-2 font-sans text-sm md:text-base text-gray-700" data-id="element-95">
                  <span aria-hidden="true" data-id="element-96">✅</span>
                  <span data-id="element-97">{item}</span>
                </div>)}
            </div>

            <div className="w-full flex flex-col sm:flex-row items-stretch sm:items-center justify-center lg:justify-start gap-4 mb-5 lg:mb-6" data-id="element-98">
              <button onClick={scrollToOffer} className="w-full sm:w-auto px-7 py-4 md:px-11 md:py-5 bg-ocean-teal-dark hover:bg-ocean-teal text-white rounded-2xl font-bold text-base md:text-xl tracking-wide transition-all shadow-soft-lg hover:shadow-soft hover:-translate-y-0.5 flex items-center justify-center gap-2.5" data-id="element-99">
                <Sparkles className="w-5 h-5" aria-hidden="true" data-id="element-100" />
                QUIERO EL SISTEMA 360
              </button>
            </div>

            {/* Trust strip */}
            <div className="w-full flex flex-row flex-wrap lg:justify-start text-sm text-gray-500 gap-[6px] items-center justify-start" data-id="element-101">
              <span className="flex items-center gap-1.5" data-id="element-102">
                <span aria-hidden="true" data-id="element-103">⚡</span>
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-104">
                <span aria-hidden="true" data-id="element-105">🔒</span>
                Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-106">
                <span aria-hidden="true" data-id="element-107">🛡️</span>
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-108">
                <span aria-hidden="true" data-id="element-109">💳</span>
                Mercado Pago
              </span>
            </div>
          </motion.div>

          {/* Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative flex items-center justify-center mt-2 lg:mt-0 order-1 lg:order-2" data-id="element-110">
            <div className="relative w-full max-w-[300px] sm:max-w-sm lg:max-w-md" data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/tVs8BpRnFBBL77vG8nvaDX/mockup1.png" alt="Sistema 360 Lash — 6 tomos, 6 bonos y Acelerador Profesional" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-112" />

              {/* Top label */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-ocean-gold text-white text-xs sm:text-sm font-bold px-4 py-1.5 rounded-full shadow-md whitespace-nowrap" data-id="element-113">
                Sistema 360 + Bonos
              </div>

              {/* Floating Extra Premium badge */}
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 4,
              ease: 'easeInOut'
            }} className="absolute -bottom-3 -right-1 sm:-right-4 bg-white p-2.5 sm:p-4 rounded-2xl shadow-soft-lg border border-gray-50 flex items-center gap-2 sm:gap-3" data-id="element-114">
                <div className="w-9 h-9 sm:w-12 sm:h-12 rounded-full bg-ocean-gold-light flex items-center justify-center shrink-0" data-id="element-115">
                  <span className="text-lg sm:text-2xl" aria-hidden="true" data-id="element-116">
                    🎁
                  </span>
                </div>
                <div data-id="element-117">
                  <p className="text-[10px] sm:text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-118">
                    Extra Premium
                  </p>
                  <p className="text-xs sm:text-sm font-bold text-gray-900" data-id="element-119">
                    Acelerador Profesional
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}